export default __webpack_public_path__ + "static/First-aa10a82df58c254b9279da738c8d4586.jpg";